var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeekupBlueCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48.18 24.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#3c63ad;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#fff;}.cls-5{fill:#0855b2;}.cls-6{fill:#4b545a;}.cls-7{fill:#4388fc;fill-opacity:0.1;}.cls-10,.cls-18,.cls-8,.cls-9{fill-opacity:0.77;}.cls-8{fill:url(#radial-gradient);}.cls-9{fill:url(#radial-gradient-2);}.cls-10{fill:url(#radial-gradient-3);}.cls-11{fill:#594f4f;}.cls-12{fill:url(#linear-gradient);}.cls-13{fill:url(#linear-gradient-2);}.cls-14{fill:#d5e3f0;}.cls-15{fill:url(#linear-gradient-3);}.cls-16{fill:url(#linear-gradient-4);}.cls-17{fill:#d8394c;}.cls-18{fill:url(#radial-gradient-4);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.05,
    y: 6.48,
    width: 8.01,
    height: 10.3,
    transform: "translate(7.36 30.64) rotate(-89.8)",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -26.63,
    cy: 68.25,
    r: 1,
    gradientTransform: "matrix(-7.67, 0, 0, 25.5, -193.65, -1727.88)",
    gradientUnits: "userSpaceOnUse",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.8,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -24.78,
    cy: 76.52,
    r: 1,
    gradientTransform: "matrix(-26.27, -0.02, 0, 3.36, -643.44, -253.71)",
    xlinkHref: "#radial-gradient",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -24.78,
    cy: 76.5,
    r: 1,
    gradientTransform: "matrix(-26.27, -0.02, 0, 3.37, -643.44, -237.43)",
    xlinkHref: "#radial-gradient",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 44.19,
    y1: 31.11,
    x2: 44.19,
    y2: 27.58,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 34)",
    gradientUnits: "userSpaceOnUse",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a1a1a1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 44.19,
    y1: 31.11,
    x2: 44.19,
    y2: 27.58,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 34)",
    gradientUnits: "userSpaceOnUse",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#333",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#333",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 44.19,
    y1: 12.87,
    x2: 44.19,
    y2: 16.4,
    xlinkHref: "#linear-gradient",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 44.19,
    y1: 12.87,
    x2: 44.19,
    y2: 16.4,
    xlinkHref: "#linear-gradient-2",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -25.98,
    cy: 68.22,
    r: 1,
    gradientTransform: "matrix(-10.4, -0.12, -0.3, 26.06, -224.1, -1769.07)",
    xlinkHref: "#radial-gradient",
    fill: "#000000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.69,22.4l1.73-.11a8.72,8.72,0,0,0,4.34-1.46c2.34-1.61,3.28-4,3.42-7.41V10.68c-.14-3.45-1.08-5.8-3.42-7.4a8.62,8.62,0,0,0-4.34-1.46l-1.73-.11a20.7,20.7,0,0,0-3.34.06l-.25,0h-28a10.31,10.31,0,0,0-3.83.89C1,3.66,0,5.67,0,11.1V13c0,5.42,1,7.44,3.25,8.4a10.51,10.51,0,0,0,3.83.89h28l.25,0A23.4,23.4,0,0,0,38.69,22.4Zm-4.87-2-6.1-1.21c-.41-.08-.82-.15-1.24-.21a27.51,27.51,0,0,0,0-13.9c.42-.06.83-.14,1.24-.22l6.1-1.2A2.77,2.77,0,0,1,37,5.34a17.94,17.94,0,0,1,1,6.15v1a17.87,17.87,0,0,1-1,6.15A2.76,2.76,0,0,1,33.82,20.37Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.19,15.65a.59.59,0,0,0,0-.14,2.19,2.19,0,0,0-.57-1.4,2.52,2.52,0,0,0-2-.63c-.86,0-1.48,0-1.48,0A5.69,5.69,0,0,1,19,13.22a7.1,7.1,0,0,1-1.52-.67l-1,1-.65-3.95,3.88.47-.94,1a4.66,4.66,0,0,0,1.72.68,4.61,4.61,0,0,0,.84.07h.32v-.23A4.05,4.05,0,0,0,21,9.41a4,4,0,0,0-1.75-1.49A3.86,3.86,0,0,0,17,7.69a3.8,3.8,0,0,0-2,1.09,4.09,4.09,0,0,0-.85,4.37A4,4,0,0,0,15.62,15a3.83,3.83,0,0,0,2.17.67Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.85,7.09l-9.6-.86v.11l9.54,1.2A.9.9,0,0,1,46.85,7.09Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.85,17l-9.6.86v-.11l9.54-1.19A.89.89,0,0,0,46.85,17Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8.72,19.77a7.41,7.41,0,0,1-2.65-.39.72.72,0,0,0,.22-.1L5.58,19A3.07,3.07,0,0,1,4.1,17.21a15.32,15.32,0,0,1-.64-3.86c0-.39,0-.77,0-1.15v-.26c0-.38,0-.75,0-1.12A15.4,15.4,0,0,1,4.1,6.94,3,3,0,0,1,5.58,5.18C5.8,5.07,6,5,6.3,4.86l-.17-.09a6.89,6.89,0,0,1,2.59-.41c.46,0,.92,0,1.39.07V19.69A11,11,0,0,1,8.72,19.77Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8.72,19.77a7.41,7.41,0,0,1-2.65-.39.72.72,0,0,0,.22-.1L5.58,19A3.07,3.07,0,0,1,4.1,17.21a15.32,15.32,0,0,1-.64-3.86c0-.39,0-.77,0-1.15v-.26c0-.38,0-.75,0-1.12A15.4,15.4,0,0,1,4.1,6.94,3,3,0,0,1,5.58,5.18C5.8,5.07,6,5,6.3,4.86l-.17-.09a6.89,6.89,0,0,1,2.59-.41c.46,0,.92,0,1.39.07V19.69A11,11,0,0,1,8.72,19.77Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M8.72,19.77a7.41,7.41,0,0,1-2.65-.39.72.72,0,0,0,.22-.1L5.58,19A3.07,3.07,0,0,1,4.1,17.21a15.32,15.32,0,0,1-.64-3.86c0-.39,0-.77,0-1.15v-.26c0-.38,0-.75,0-1.12A15.4,15.4,0,0,1,4.1,6.94,3,3,0,0,1,5.58,5.18C5.8,5.07,6,5,6.3,4.86l-.17-.09a6.89,6.89,0,0,1,2.59-.41c.46,0,.92,0,1.39.07V19.69A11,11,0,0,1,8.72,19.77Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.45,4.71,9.83,4.65a.46.46,0,0,1-.2-.05.6.6,0,0,1-.33-.72c.16-.49.61-.74,1.42-.76l22.55-.49h0l0,0-.51.26a1.59,1.59,0,0,1-.35.13l-3.87.74a43.14,43.14,0,0,1-7.46.83C17.6,4.81,15.22,4.77,12.45,4.71Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M12.45,4.71,9.83,4.65a.46.46,0,0,1-.2-.05.6.6,0,0,1-.33-.72c.16-.49.61-.74,1.42-.76l22.55-.49h0l0,0-.51.26a1.59,1.59,0,0,1-.35.13l-3.87.74a43.14,43.14,0,0,1-7.46.83C17.6,4.81,15.22,4.77,12.45,4.71Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12.45,4.71,9.83,4.65a.46.46,0,0,1-.2-.05.6.6,0,0,1-.33-.72c.16-.49.61-.74,1.42-.76l22.55-.49h0l0,0-.51.26a1.59,1.59,0,0,1-.35.13l-3.87.74a43.14,43.14,0,0,1-7.46.83C17.6,4.81,15.22,4.77,12.45,4.71Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.63,2.93a4.27,4.27,0,0,0-.53,1.79l1.37-.06A7.17,7.17,0,0,1,21.8,2.87Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.5,3.42l.19-.73,2.58,0h0l0,0-.51.26a1.2,1.2,0,0,1-.35.12Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.45,19.4l-2.62.05a.36.36,0,0,0-.2.06.59.59,0,0,0-.33.71c.16.5.61.75,1.42.77l22.55.49h0l0,0-.51-.26a1.21,1.21,0,0,0-.35-.13l-3.89-.75a44.22,44.22,0,0,0-7.46-.84C17.6,19.28,15.22,19.34,12.45,19.4Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M12.45,19.4l-2.62.05a.36.36,0,0,0-.2.06.59.59,0,0,0-.33.71c.16.5.61.75,1.42.77l22.55.49h0l0,0-.51-.26a1.21,1.21,0,0,0-.35-.13l-3.89-.75a44.22,44.22,0,0,0-7.46-.84C17.6,19.28,15.22,19.34,12.45,19.4Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M12.45,19.4l-2.62.05a.36.36,0,0,0-.2.06.59.59,0,0,0-.33.71c.16.5.61.75,1.42.77l22.55.49h0l0,0-.51-.26a1.21,1.21,0,0,0-.35-.13l-3.89-.75a44.22,44.22,0,0,0-7.46-.84C17.6,19.28,15.22,19.34,12.45,19.4Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.62,21.18a4.32,4.32,0,0,1-.53-1.79l1.38.05a6.57,6.57,0,0,0,1.32,1.79Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.5,20.69l.18.72,2.58.06h.05l0,0-.5-.26a1.48,1.48,0,0,0-.35-.13Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M32,2.94a1.14,1.14,0,0,1-.55,0V2.19H32Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.87,2.31h-.75a.2.2,0,0,1-.18-.14L30.3.22a.12.12,0,0,1,.08-.15A1.35,1.35,0,0,1,30.72,0H31a.93.93,0,0,1,.51.21,1.38,1.38,0,0,1,.35.45,2.61,2.61,0,0,1,.21,1c0,.16,0,.37,0,.53A.16.16,0,0,1,31.87,2.31Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M32,21.16a1,1,0,0,0-.55,0v.75H32Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.87,21.78h-.76a.2.2,0,0,0-.18.14l-.64,1.95a.12.12,0,0,0,.08.15,1.49,1.49,0,0,0,.34.06,2.08,2.08,0,0,0,.25,0,1,1,0,0,0,.51-.2,1.33,1.33,0,0,0,.35-.46,2.38,2.38,0,0,0,.21-1,4.69,4.69,0,0,0,0-.53A.15.15,0,0,0,31.87,21.78Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M46.52,6.41a7.1,7.1,0,0,0-4.66-3.53h1.08a2.69,2.69,0,0,1,1.73.63A5.23,5.23,0,0,1,46.52,6.41Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M46.52,6.41a7.1,7.1,0,0,0-4.66-3.53h1.08a2.69,2.69,0,0,1,1.73.63A5.23,5.23,0,0,1,46.52,6.41Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M41.87,2.89h1.07a2.69,2.69,0,0,1,1.73.63,5.17,5.17,0,0,1,1.85,2.89A7,7,0,0,0,41.87,2.89Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M46.52,17.6a7.07,7.07,0,0,1-4.66,3.53h1.08a2.64,2.64,0,0,0,1.73-.63A5.16,5.16,0,0,0,46.52,17.6Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M46.52,17.6a7.07,7.07,0,0,1-4.66,3.53h1.08a2.64,2.64,0,0,0,1.73-.63A5.16,5.16,0,0,0,46.52,17.6Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M41.87,21.13h1.07a2.64,2.64,0,0,0,1.73-.63,5.19,5.19,0,0,0,1.87-2.9A7.13,7.13,0,0,1,41.87,21.13Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M.47,6.2A4.7,4.7,0,0,1,3.24,2.68l1.1-.4-.06.18A2.18,2.18,0,0,1,3.08,3.8a3.53,3.53,0,0,0-2,2.06A.64.64,0,0,1,.47,6.2Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M.47,17.89a4.66,4.66,0,0,0,2.77,3.52c.39.16.75.29,1.09.41l0-.18a2.2,2.2,0,0,0-1.2-1.35,3.52,3.52,0,0,1-2-2.05A.63.63,0,0,0,.47,17.89Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.78,12.49a17.49,17.49,0,0,1-1,6.08A2.52,2.52,0,0,1,33.29,20l-5.52-1.09-1-.18a33.29,33.29,0,0,0,.85-6.9,28.7,28.7,0,0,0-.85-6.61c.33-.06.68-.11,1-.18L33.29,4a2.56,2.56,0,0,1,1.48,1.46,17.75,17.75,0,0,1,1,6.07Zm.23,0v-1a18.16,18.16,0,0,0-1-6.15,2.76,2.76,0,0,0-1.68-1.61l-5.6,1.1-1.24.22a29.36,29.36,0,0,1,.89,6.81,33.54,33.54,0,0,1-.89,7.1c.42.06.83.13,1.24.21l5.59,1.1A2.79,2.79,0,0,0,35,18.68,18.23,18.23,0,0,0,36,12.49Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.31,20.27l-5.59-1.11c-.41-.08-.83-.15-1.24-.21a27.51,27.51,0,0,0,0-13.9c.41-.06.83-.14,1.24-.22l5.59-1.1A2.81,2.81,0,0,1,35,5.34a18,18,0,0,1,1,6.15v1a17.89,17.89,0,0,1-1,6.15A2.77,2.77,0,0,1,33.31,20.27Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.31,20.27l-5.59-1.11c-.41-.08-.83-.15-1.24-.21a27.51,27.51,0,0,0,0-13.9c.41-.06.83-.14,1.24-.22l5.59-1.1A2.81,2.81,0,0,1,35,5.34a18,18,0,0,1,1,6.15v1a17.89,17.89,0,0,1-1,6.15A2.77,2.77,0,0,1,33.31,20.27Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M33.31,20.27l-5.59-1.11c-.41-.08-.83-.15-1.24-.21a27.51,27.51,0,0,0,0-13.9c.41-.06.83-.14,1.24-.22l5.59-1.1A2.81,2.81,0,0,1,35,5.34a18,18,0,0,1,1,6.15v1a17.89,17.89,0,0,1-1,6.15A2.77,2.77,0,0,1,33.31,20.27Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.82,20.37A2.78,2.78,0,0,0,37,18.66a17.93,17.93,0,0,0,1-6.16v-1a17.89,17.89,0,0,0-1-6.15,2.77,2.77,0,0,0-3.13-1.71l-.51.1A2.78,2.78,0,0,1,35,5.36a18,18,0,0,1,1,6.15v1a17.91,17.91,0,0,1-1,6.16,2.78,2.78,0,0,1-1.68,1.61Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47,16.93s0,0,0-.14V7.31a.32.32,0,0,1,0-.13s.06,0,.14.13l0,.08A6.66,6.66,0,0,1,48,8.8a17.74,17.74,0,0,1,.17,1.88v2.74A17.54,17.54,0,0,1,48,15.29h0a6.74,6.74,0,0,1-.81,1.42l0,.08C47.06,16.91,47,16.93,47,16.93Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.21,4.65v14.8A4.14,4.14,0,0,1,9,19C6.5,17.6,6.64,6.14,9,5.1A5.16,5.16,0,0,1,11.21,4.65Z",
    fill: "#000000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeekupBlueCar);
export default __webpack_public_path__ + "static/media/PeekupBlueCar.04097eae9f20cfa73b82b4dda423bd8e.svg";
export { ForwardRef as ReactComponent };